import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import styles from '~styles/modalStyles.scss';
import { closeNotification } from '~actions/transferActions';

const bind = classNames.bind(styles);

const Notification = ({
  showNotification,
  notificationText,
  notificationHeader,
  closeNotification,
}) => {
  // HACK HACK HACK! FIXME!
  setTimeout(closeNotification, notificationHeader ? 3000 : 1000);

  const notificationTextStyles = bind({
    modalContentWrapper: true,
    alingContentCenter: !notificationHeader,
  });

  return (
    <div
      className={
        showNotification ? styles.notification : styles.notificationHidden
      }
    >
      {notificationHeader && (
        <div className={styles.modalHeader}>{notificationHeader}</div>
      )}
      <div className={notificationTextStyles}>{notificationText}</div>
    </div>
  );
};

export default connect(
  state => ({
    showNotification: state.transferReducers.showNotification,
    notificationText: state.transferReducers.notificationText,
    notificationHeader: state.transferReducers.notificationHeader,
  }),
  { closeNotification }
)(Notification);
